import React from "react";

type Props = {
  width:number,
  height:number,
  color:string
}

const CheckCircle : React.FC<Props> = ({width,height,color},props)  => (
  <svg width={width} height={height}  viewBox="0 0 14 14" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.81347 4.86022L5.95347 7.72689L4.85347 6.62689C4.69054 6.43664 4.43472 6.35377 4.19119 6.41235C3.94766 6.47093 3.75751 6.66108 3.69893 6.90461C3.64035 7.14814 3.72322 7.40396 3.91347 7.56689L5.48014 9.14022C5.60595 9.26501 5.77627 9.33458 5.95347 9.33356C6.12836 9.33282 6.29596 9.26339 6.42014 9.14022L9.75347 5.80689C9.87968 5.68171 9.95067 5.51132 9.95067 5.33356C9.95067 5.1558 9.87968 4.9854 9.75347 4.86022C9.49344 4.60174 9.07349 4.60174 8.81347 4.86022ZM7.00016 0.333496C3.31826 0.333496 0.333496 3.31826 0.333496 7.00016C0.333496 10.6821 3.31826 13.6668 7.00016 13.6668C10.6821 13.6668 13.6668 10.6821 13.6668 7.00016C13.6668 5.23205 12.9645 3.53636 11.7142 2.28612C10.464 1.03588 8.76827 0.333496 7.00016 0.333496ZM7.00016 12.3335C4.05464 12.3335 1.66683 9.94568 1.66683 7.00016C1.66683 4.05464 4.05464 1.66683 7.00016 1.66683C9.94568 1.66683 12.3335 4.05464 12.3335 7.00016C12.3335 8.41465 11.7716 9.7712 10.7714 10.7714C9.7712 11.7716 8.41465 12.3335 7.00016 12.3335Z"
      fill={color}
    />
  </svg>
);

export default CheckCircle;